export default __webpack_public_path__ + "static/media/Poppins-Bold.b1c32aa5.ttf";